import React, { memo } from 'react'
import { showModal } from '../../../../../store/actions/modalActions'
import { ModalTypes } from '../../../../../types/modals'
import AppButton from '../../../../buttons/AppButton/AppButton'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch'
import { MoveToPosition } from '../../../../overlays/MoveToPosition/MoveToPosition'
import { showRightBar } from '../../../../../store/actions/rightBarActions'
import { TableAdvanced } from '../TableAdvanced/TableAdvanced'

interface Props {
    data: any
    items: any[]
    index: number
    focusIndex: number
    onItemFocus: (index: number) => void
    onDeleteItem: (index: number) => void
    onPositionChange: (index: number) => (toPosition: number) => void
    schema?: any
    parentSchema?: any
    dataPath?: string[]
    name: string
    isOrderUserDefined: boolean
    isRuleCard?: boolean
}

export const BlockArrayTableRow = memo(function BlockArrayTableRow({
    data,
    items,
    focusIndex,
    onItemFocus,
    onDeleteItem,
    onPositionChange,
    index,
    schema,
    parentSchema,
    dataPath = [], // NOTE added default value
    name,
    isOrderUserDefined,
    isRuleCard,
}: Props){
    const dispatch = useAppDispatch()
    const position = index + 1

    const rowDelete = () => {
        onDeleteItem(index)
        if (focusIndex === index) onItemFocus(-1)
    }

    const handleDelete = () =>
        dispatch(
            showModal(ModalTypes.MAIN_MODAL, {
                body: `Delete row ${position}?`,
                onSubmit: rowDelete,
            })
        )

    const handlePositionChange = (toPosition: number) => {
        return onPositionChange(index)(toPosition)
    }

    const openEditMode = () => {
        dispatch(
            showRightBar({
                rightBarItem: (
                    <TableAdvanced
                        label={schema.name || name}
                        config={items}
                        schema={parentSchema}
                        path={dataPath}
                        itemEditIndex={index}
                        isRuleCard={isRuleCard}
                    />
                ),
                disableHide: true
            })
        )
    }

    return (
        <>
            <td onClick={openEditMode as any}>{position}</td>

            {Object.keys(schema)
                .filter((key: any) => key !== 'element_id')
                .map((keyName: any) =>
                    schema[keyName]?.['type'] === 'secret' ? (
                        <td
                            key={keyName}
                            onClick={openEditMode as any}
                        >
                            ******
                        </td>
                    ) : (
                        <td
                            key={keyName}
                            onClick={openEditMode as any}
                        >
                            {String(data[keyName])}
                        </td>
                    )
                )}
            <td style={{ verticalAlign: 'top' }}>
                <div className={`d-flex justify-content-center`}>
                    {isOrderUserDefined && (
                        <MoveToPosition
                            position={Number(position)}
                            maxPosition={items.length}
                            onSubmit={handlePositionChange}
                            disabled={false}
                            className="btn light-blue"
                            popoverPlacement="left"
                        />
                    )}
                    <AppButton
                        variant="edit"
                        onClick={openEditMode}
                        tooltip="tooltips.editRow"
                        className="light-blue"
                    />
                    <AppButton
                        variant="delete"
                        onClick={handleDelete}
                        tooltip="tooltips.deleteRow"
                        className="bleak-red"
                    />
                </div>
            </td>
        </>
    )
})